var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-login" },
    [
      _c("div", { staticClass: "page-login--wrapper" }, [
        _c("div", { staticClass: "page-login--panel page-login--brand" }, [
          _c("div", { staticClass: "brand-content" }, [
            _c("div", { staticClass: "brand-illustration" }, [
              _c("img", { attrs: { src: _vm.login_img, alt: "电商插画" } })
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "page-login--panel page-login--form-container" },
          [
            _c(
              "div",
              { staticClass: "form-content" },
              [
                _c("div", { staticClass: "form-header" }, [
                  _c("h3", [_vm._v("账号登录")]),
                  _c("p", [_vm._v("当前时间: " + _vm._s(_vm.time))])
                ]),
                _vm.errorMsg
                  ? _c("el-alert", {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: {
                        title: _vm.errorMsg,
                        type: "error",
                        "show-icon": "",
                        closable: false
                      }
                    })
                  : _vm._e(),
                _c(
                  "el-form",
                  {
                    ref: "loginForm",
                    attrs: {
                      "label-position": "top",
                      rules: _vm.rules,
                      model: _vm.formLogin,
                      size: "large"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "username" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入用户名",
                            "prefix-icon": "fa fa-user-circle-o"
                          },
                          model: {
                            value: _vm.formLogin.username,
                            callback: function($$v) {
                              _vm.$set(_vm.formLogin, "username", $$v)
                            },
                            expression: "formLogin.username"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "password" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "password",
                            placeholder: "请输入密码",
                            "show-password": "",
                            "prefix-icon": "fa fa-keyboard-o"
                          },
                          model: {
                            value: _vm.formLogin.password,
                            callback: function($$v) {
                              _vm.$set(_vm.formLogin, "password", $$v)
                            },
                            expression: "formLogin.password"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "code" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "二次验证码",
                            "prefix-icon": "el-icon-menu"
                          },
                          model: {
                            value: _vm.formLogin.code,
                            callback: function($$v) {
                              _vm.$set(_vm.formLogin, "code", $$v)
                            },
                            expression: "formLogin.code"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { prop: "captcha_code" } }, [
                      _c(
                        "div",
                        { staticClass: "captcha-wrapper" },
                        [
                          _c("el-input", {
                            staticStyle: { flex: "1", "margin-right": "10px" },
                            attrs: {
                              placeholder: "图片验证码",
                              "prefix-icon": "el-icon-picture-outline"
                            },
                            model: {
                              value: _vm.formLogin.captcha_code,
                              callback: function($$v) {
                                _vm.$set(_vm.formLogin, "captcha_code", $$v)
                              },
                              expression: "formLogin.captcha_code"
                            }
                          }),
                          _c("div", {
                            staticClass: "captcha-img",
                            attrs: { title: "点击刷新" },
                            domProps: { innerHTML: _vm._s(_vm.captchaSvg) },
                            on: { click: _vm.getCaptcha }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "form-options" },
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.rememberMe,
                              callback: function($$v) {
                                _vm.rememberMe = $$v
                              },
                              expression: "rememberMe"
                            }
                          },
                          [_vm._v("记住我")]
                        ),
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary", underline: false },
                            on: { click: _vm.clickBindCode }
                          },
                          [_vm._v("绑定二维码")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "button-login",
                        attrs: { type: "primary", loading: _vm.loading },
                        on: { click: _vm.submit }
                      },
                      [_vm._v(" 登 录 ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ]),
      _c("google-code", { ref: "googleCode" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }